import { Injectable} from '@angular/core';
import { EncryptDataService } from './encrypt-data.service';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { User } from 'app/Authentification/login-form/user.model';
import { releaseVersion } from 'release-version';


@Injectable()
export class ConstantService {
    public user: User = new User;
    public previousURl: any = "/pages/MainDashboard";
    public prodApiUrl:any = 'https://www.tradingrsms.com/'
    public currentURL: string ="";
    public MainMenu: string="";
    public SubMenu: string="";
    public isSessionExpired: boolean= false;
    public sessionTimeout = 1000*60*60*4;
    public defaultToastLife: number = 8000; // 8 seconds
      // pagination
    public DEFAULT_paginatorPosition = 'Both';
    public DEFAULT_PAGENUMBER = 1;
    public DEFAULT_SORDORDER_ASC = 1;
    public DEFAULT_SORDORDER_DESC = -1;
    public DEFAULT_ROWSIZE = this.getGridRowsCount();
    public DEFAULT_PAGELINKS = 10; // used for primeng
    public GRID_DEFAULT_PAGELINKS = 5; // used to avoid overflow
    public DEFAULT_ROWSPERPAGEOPTION:any = [15, 20, 30, 50, 100, 200, 300, 400, 500];
    public DELETE_CONFIRM_MESSAGE = 'Are you sure you want to permanently remove this exception?';
    public RESTORE_CONFIRM_MESSAGE = 'Are you sure you want to restore back this exception?';
    public APPLY_SUGGEST_CONFIRM_MESSAGE = 'Are you sure you want to apply suggest for these exceptions?';
    public NO_RECORDFOUND_MSG = 'No Record Found.';
    public LOADIND_DATA_MSG = 'L o a d i n g . . . . .';
    public IDLE_TIMEOUT = 10800;
    // messages
    MESSAGE_SEVERITY_ERROR = 'error';
    MESSAGE_SEVERITY_SUCCESS = 'success';
    MESSAGE_SEVERITY_INFO = 'info';
    MESSAGE_SEVERITY_WARN = 'warn';
    MESSAGE_SUMMARY_ERROR = 'Error Message';
    MESSAGE_SUMMARY_SUCCESS = 'Success Message';
    MESSAGE_SUMMARY_WARN = 'Warning Message';
    MESSAGE_SUMMARY_INFO = 'Info Message';

    MESSAGE_DELETE_SUCCESS_MSG = 'Record deleted successfully';
    MESSAGE_DELETE_ERROR_MSG = 'Error in deleting the record';
    MESSAGE_RESTORE_SUCCESS_MSG = 'Record restored successfully';
    MESSAGE_RESTORE_ERROR_MSG = 'Error in restoring the record';
    MESSAGE_APPLY_SUGGEST_SUCCESS_MSG = 'Applied suggested values for selected records successfully';
    MESSAGE_APPLY_SUGGEST_ERROR_MSG = 'Error in applying suggested values for the record';
    MESSAGE_MASS_CORRECTION_ERROR_MSG = 'Mass Correction is in progress. Please check back later.';

    
    //patterns
    public NUMERIC_PATTERN = "^[0-9]{0,}$";
    public ALPHANUMERIC_PATTERN_WITHSPACE = "^[A-Za-z]{1,}[A-Za-z0-9\\s]{0,}$";
    public DATE_YYYY_MM_DD ="^\\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$";
    public static passwordRegex = "^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#:\$%\^&\*_><,^~;:-`]).{8,}$";

    // input fields related
    public NUMERIC_MAXLENGTH = 10;
    public NUMBER_MAX_EXPORT_ROWS = 20000;
    public NUMBER_0 = 0;

    // boolean dropdown value
    BOOLEAN_DROPDOWN: any = [{
        label: "true", value: true, description: "True"
      },
      {
        label: "false", value: false, description: "False"
      }];
    rowcount: number = 0;

    public rsmsStatusDropDwn=[
        {
          "value": "N",
          "label": "New",
          "isDefault": null,
          "isActive": false,
          "sequenceNo": 0,
          "description": "New"
        },
        {
          "value": "U",
          "label": "Updated",
          "isDefault": null,
          "isActive": true,
          "sequenceNo": 0,
          "description": "Updated"
        },
        {
          "value": "D",
          "label": "Deleted",
          "isDefault": null,
          "isActive": true,
          "sequenceNo": 0,
          "description": "Deleted"
        },
        {
          "value": "C",
          "label": "Corrected",
          "isDefault": null,
          "isActive": true,
          "sequenceNo": 0,
          "description": "Corrected"
        },
        {
          "value": "G",
          "label": "Generated",
          "isDefault": null,
          "isActive": false,
          "sequenceNo": 0,
          "description": "Generated"
        },
        {
          "value": "F",
          "label": "FINRA Confirmed",
          "isDefault": null,
          "isActive": false,
          "sequenceNo": 0,
          "description": "FINRA Confirmed"
        },
        {
          "value": "E",
          "label": "Error Record",
          "isDefault": null,
          "isActive": false,
          "sequenceNo": 0,
          "description": "Error Record"
        }];

        public statusDropDwn=[
          {
            "value": "Open",
            "label": "Open",
          },
          {
            "value": "CLOSED",
            "label": "Close",
          },
         ];
  

    public EVENT_DESCRIPTION_BY_EVENT_TYPE: any = {
        NW: 'New Order',
        CC: 'Order Cancel Confirmed',
        UR: 'Order Cancel Replace/Order Adjust Confirmed',
        CR: 'Cancel Replace',
        CL: 'Cancel Order',
        UP: 'Order Update',
        DO: 'Desk Order',
        RI: 'Order Reinstate',
        BO: 'Bunched/ Aggregated Order',
        CO: 'Child Order',
        AJ: 'Order Adjustment',
        OJ: 'Order Reject',
        RJ: 'Order Adjustment Reject/Route Reject',
        CJ: 'Order Cancel Reject',
        RO: 'Rejected Order',
        RA: 'Rejected Order Adjustment/Route Acknowledgement',
        RX: 'Rejected Order Cancel',
        RC: 'Rejected Child Order/Route Cancel',
        RT: 'Route Order',
        RR: 'Route Replace',
        DS: 'Desk Route',
        XR: 'Rejected Route',
        XX: 'Rejected Route Replace',
        TR: 'Trade',
        TC: 'Trade Correct',
        TX: 'Trade Cancel',
        TU: 'Trade Update',
        AL: 'New Allocation',
        AA: 'Allocation Amend',
        AC: 'Allocation Cancel'
      };

  public CONVERT_EVENT_JSON:any = {
    MECO: 'MENO',
    MOCO: 'MONO',
    MENO: 'MEOA',
    MEOA: 'MENO',
    MONO: 'MOOA',
    MOOA: 'MONO',
    MLNO: 'MLOA',
    MLOA: 'MLNO'
  };

    public CONVERT_EVENT_LIST = 'MECO,MOCO,MENO,MEOA,MONO,MOOA,MLNO,MLOA,MEOR,MLOR,MOOR,MEOM,MOOM,MEMR';

    public FilterEventTypes = [
      'Equities', 'Options', 'Single-Leg','Multi-Leg', 'Allocations', 'Representative Orders'
    ];
    
    public ExportablemultiDimensinalColumns: any  = {
        'buyDetails': ['orderKeyDate', 'orderID', 'side', 'firmDesignatedID', 'accountHolderType', 'originatingIMID'], 
        'sellDetails': ['orderKeyDate', 'orderID', 'side', 'firmDesignatedID', 'accountHolderType', 'originatingIMID'],
        'aggregatedOrders': ['orderID', 'orderKeyDate', 'quantity', 'originatingIMID'],
        'clientDetails': ['orderKeyDate', 'orderID', 'side', 'firmDesignatedID', 'accountHolderType', 'originatingIMID'],
        'firmDetails': ['orderKeyDate', 'orderID', 'side', 'firmDesignatedID', 'accountHolderType', 'originatingIMID'],
        'legDetails': ['legRefID', 'symbol', 'optionID', 'openCloseIndicator', 'side', 'legRatioQuantity']
    };
    
    public SaveFilterQueryAccessibleApplications = [
        'CAT-ROE-Viewer', 'Orders', 'Routes', 'Trades', 'Allocations','Comparative-Review-Report'
    ];

    public customerTypes = ['Natural-Person', 'Legal-Entity'];

    public CAT_FIELD_DICTIONARY_KEY = "CAT_FIELD_DICTIONARY"; 

    public validSidesMEEventTypes: any = ["B", "SL", "SS", "SX"];
    public validSidesMOEventTypes: any = ["B", "S"];

    public inquirySelectionValues: any = [
        {
            "inquiryFields": {
                "status": ["Initiated", "Modified", "Executing", "Re-initiated", "Completed", "Deleted"],
                "inquiryStatusFilters": [{ "label": "Initiated", "value": "Initiated" }, { "label": "Modified", "value": "Modified" }, { "label": "Executing", "value": "Executing" }, { "label": "Re-initiated", "value": "Re-initiated" }, { "label": "Completed", "value": "Completed" }, { "label": "Deleted", "value": "Deleted" }],
                "inquiryRequestor": ["Finra Informal Inquiry", "Finra Audit", "Other"],
                "inquiryRequestorFilters": [{ "label": "Please Select", "value": "" }, { "label": "Finra Informal Inquiry", "value": "Finra Informal Inquiry" }, { "label": "Finra Audit", "value": "Finra Audit" }, { "label": "Other", "value": "Other" }]
            },
            "inquiryQueryFields": {
                "status": ["Initiated", "Modified", "Executing", "Re-initiated", "Success", "Not Found", "Deleted"]
            }
        }
    ];

     // CAT Analytics
     PERCENTAGE_CHANGE = 10;

     public filterByString = [
      { label: 'IS', value: 'IS' },
      { label: 'IN', value: 'IN' },
      { label: 'NOT IN', value: 'NOT IN' },
      { label: 'LIKE', value: 'LIKE' },
      { label: 'NOT LIKE', value: 'NOT LIKE' },
      { label: 'IS NULL', value: 'IS NULL' },
      { label: 'NOT NULL', value: 'NOT NULL' },
      { label: 'STARTS WITH', value: 'STARTS WITH' },
      { label: 'ENDS WITH', value: 'ENDS WITH' }
    ];
    public filterByInt = [
      { label: '=', value: '=' },
      { label: '<', value: '<' },
      { label: '>', value: '>' },
      { label: '<=', value: '<=' },
      { label: '>=', value: '>=' },
      { label: '<>', value: '<>' }
    ];

    public filterByBoolean = [
      { label: 'True', value: 'true' },
      { label: 'False', value: 'false' }
    ];

    constructor(private encryptDataService: EncryptDataService,
        private cookieService: CookieService,
        private router: Router) { 
        }

    getGridRowsNumner() {
        let rowcount:any = $(window).innerHeight();
        rowcount = Math.round((rowcount - 300) / 22);
        if (rowcount <= 15)
            rowcount = 15;
        return rowcount;
    }

    // set data to local storage key
    public setStorage(key: string, value: any) {
        localStorage.setItem(key, this.encryptDataService.encryptData(value));
    }
    // get data from local storage key
    public getStorage(key: string) {
        let data: any = localStorage.getItem(key);
        return this.encryptDataService.decryptData(data);
    }

    getGridRowsCount() {
        if(window.innerHeight <= 930) {
          this.rowcount = 20;
        } else if(window.innerHeight <= 1240 && window.innerHeight > 930) {
          this.rowcount = 30;
        } else if(window.innerHeight <= 1870 && window.innerHeight > 1240) {
          this.rowcount = 50;
        } else if(window.innerHeight <= 3440 && window.innerHeight > 1870) {
          this.rowcount = 100;
        }
        return this.rowcount;
    }
    
    public decryptData(data: any) {
        return this.encryptDataService.decryptData(data);
    }

    public setCookie(cname: string, cvalue: any, exdays: any) {
        this.cookieService.set(cname, this.encryptDataService.encryptData(cvalue));
    }

    public getCookie(cname: string) {
        return this.encryptDataService.decryptData(this.cookieService.get(cname));
    }

    //   public checkCookie() {
    //     var username = this.getCookie("username");
    //     if (username != "") {
    //      alert("Welcome again " + username);
    //     } else {
    //       username = prompt("Please enter your name:", "");
    //       if (username != "" && username != null) {
    //         this.setCookie("username", username, 365);
    //       }
    //     }
    //   }

    // clear data from local storage key
    public clearStorage(key: string) {
        localStorage.removeItem(key);
    }

    // clear local storage
    public clearAllStorage() {
        location.reload();
        localStorage.clear();
        // this.cookieService.deleteAll();
    }

    public deleteAllCookies(){
        // this.cookieService.deleteAll();  
    }

     public deleteCookies(item:any){
        this.cookieService.delete(item);
    }
    // encode data to get base64 string
    public encodeData(data: any) {
        return btoa(data);
    }

    // decode base64 string to get data
    public decodeData(data: any) {
        return atob(data);
    }

    // set data to session storage key
    public setSessionStorage(key: string, value: any,param1: number) {
        sessionStorage.setItem(key, this.encryptDataService.encryptData(value));
    }

    // get data from session storage key
    public getSessionStorage(key: string): string {
        let data: any = sessionStorage.getItem(key)
        return this.encryptDataService.decryptData(data);
    }

    // clear data from session storage key
    public clearSessionStorage(key: string) {
        sessionStorage.removeItem(key);
    }

    // clear session storage
    public clearAllSessionStorage() {
        sessionStorage.clear();
        // this.cookieService.deleteAll();
    }

    public routerURL(): any {
        this.currentURL = this.router.url.split('?')[0];
        if (this.currentURL != "/home") {
            let splittable: any = this.currentURL.split('/');
            this.MainMenu = splittable[2];
            this.SubMenu = splittable[3];
        }
    }

    getObjectKey(obj: any) {
        const key = Object.keys((obj))[0];
        return key;
      }

      removeNullValueObj(obj: any) {
        Object.keys(obj).forEach((key) => {
          if (obj[key] === "" || obj[key] === null) {
            delete obj[key]
          }
        })
        return obj
      }

      getTableHeaderList(data: any[]) {
        let headerList: { mappingkey: any; ui_columnname: string; datatype: any;}[] = []
        data.forEach((element: { ui_columnname: string; mappingkey: any; datatype: any; }) => {
            if(element.ui_columnname !== 'action' && element.ui_columnname !== 'Action') {
                headerList.push({'mappingkey':element.mappingkey, 'ui_columnname': this.capitalize(element.ui_columnname),'datatype': element?.datatype});
            }
        });
        return headerList;
      }

      getExportData(exportData: any[], col: any) {
        let headerList = this.getTableHeaderList(col);
        let newExportData: any = [];
            exportData.forEach(obj => {
            let json:any = {};
            headerList.forEach(header => {  
            json[header.ui_columnname] = obj[header.mappingkey] === undefined || obj[header.mappingkey] === null ||obj[header.mappingkey] === 'null' ? '' :  obj[header.mappingkey];
            if(header.datatype == 'boolean'){
              json[header.ui_columnname] = obj[header.mappingkey] == '0' ? 'false' : 'true';
            }
          });
          newExportData.push(json);
        });
        return newExportData;
      }


      parseCell(key:any,ObjectValue: string,booleanFieldList:any) {
        // Replace all double quotes with two double quotes
        let parsedValue = ObjectValue.replace(/"/g, `""`);

        // If value contains comma, new-line or double-quote, enclose in double quotes
        parsedValue = /[",\n]/.test(parsedValue) ? `"${parsedValue}"` : parsedValue;
        if(booleanFieldList[0].includes(key)){
          parsedValue = parsedValue =='0'?'false':'true';
        }
        return parsedValue;
      }

      prepareCSVDataSet(dataSetHeaders: any[], dataSetFields: string | any[], dataSet: any,booleanFieldList:any) {
        const tableData:any = [];

        tableData.push(dataSetHeaders.join(",")); // CSV Header
        // CSV Body
        for (const row of dataSet) {
          const rowData = [];
          for (let i = 0; i < dataSetFields.length; i++) {
            rowData.push(((row[dataSetFields[i]] !== null && row[dataSetFields[i]] !== undefined) ? this.parseCell(dataSetFields[i],row[dataSetFields[i]].toString(),booleanFieldList) : ""));
          }
          tableData.push(rowData.join(","));
        }

        return tableData;
      }



      getExportDataForCATAnalytics(exportData: any[], col: any[]) {
        let newExportData :any = [];
            exportData.forEach(obj => {
            let json : any = {};
            col.forEach(header => {
              if(header.field !== 'fieldNameValue') {
                json[header.header] =  JSON.parse(obj[header.field])['value'];
              } else {
                json[header.header] =  obj[header.field]
              }
       
          });
          newExportData.push(json);
        });
        return newExportData;
      }
      sortByKey(array:any, key:any) {
        return array.sort(function(a :any , b :any ) {
            let x = a[key]; let y = b[key];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
    }
    capitalize(str: string)  {
      if (typeof str !== 'string') return ''
      return str.charAt(0).toUpperCase() + str.slice(1)
    }

    getResolutionWidth(){
      return window.innerWidth - 20;
    }

    getResolutionHeight(){
      return window.innerHeight- 100;
    }

    getApplicationName() {
        this.routerURL();
        return this.SubMenu && this.SubMenu.replace(/\-/g, ' ');
    }

    populateEventList(type:any){
      let eventList = [];
      let eventType:any;
      if(type != null && type != undefined){
       eventType = type.slice(0,2).toUpperCase();
      }
      let originalEvent = this.CONVERT_EVENT_LIST.replace(/ /g, '').split(',');      
        for(let i=0;i<originalEvent.length;i++) {      
          if(originalEvent[i].startsWith(eventType) || eventType == "ML" || eventType == undefined){
             eventList.push({label:originalEvent[i],value:originalEvent[i]});
          }
        } 
        return eventList;
    }  

    dateTimeRegexCheck(checked_date:any){
      let regex = new RegExp(/^(?:(?:(?:(?:(?:[13579][26]|[2468][048])00)|(?:[0-9]{2}(?:(?:[13579][26])|(?:[2468][048]|0[48]))))(?:(?:(?:09|04|06|11)(?:0[1-9]|1[0-9]|2[0-9]|30))|(?:(?:01|03|05|07|08|10|12)(?:0[1-9]|1[0-9]|2[0-9]|3[01]))|(?:02(?:0[1-9]|1[0-9]|2[0-9]))))|(?:[0-9]{4}(?:(?:(?:09|04|06|11)(?:0[1-9]|1[0-9]|2[0-9]|30))|(?:(?:01|03|05|07|08|10|12)(?:0[1-9]|1[0-9]|2[0-9]|3[01]))|(?:02(?:[01][0-9]|2[0-8])))))(?:T)(?:0[0-9]|1[0-9]|2[0-3])(?:[0-5][0-9]){2}$/);
      if (regex.test(checked_date) == true) {
        return true;
      }
      else {
        return false;
      }
    }

    timeStampRegexCheck(checked_date:any){
      let regex = new RegExp(/^((?:(?:(?:(?:(?:[13579][26]|[2468][048])00)|(?:[0-9]{2}(?:(?:[13579][26])|(?:[2468][048]|0[48]))))(?:(?:(?:09|04|06|11)(?:0[1-9]|1[0-9]|2[0-9]|30))|(?:(?:01|03|05|07|08|10|12)(?:0[1-9]|1[0-9]|2[0-9]|3[01]))|(?:02(?:0[1-9]|1[0-9]|2[0-9]))))|(?:[0-9]{4}(?:(?:(?:09|04|06|11)(?:0[1-9]|1[0-9]|2[0-9]|30))|(?:(?:01|03|05|07|08|10|12)(?:0[1-9]|1[0-9]|2[0-9]|3[01]))|(?:02(?:[01][0-9]|2[0-8])))))(?:T)(?:0[0-9]|1[0-9]|2[0-3])(?:[0-5][0-9]){2}.(?:[0-9]){6})$/);
      if (regex.test(checked_date) == true) {
        return true;
      }
      else {
        return false;
      }
    }

    storeInLocalStorage(key: string, data: any[]): void {
      localStorage.setItem(key, JSON.stringify(data));
    }
  
    fetchFromLocalStorage(key: string): any[] {
      const storedData = localStorage.getItem(key);
      return storedData ? JSON.parse(storedData) : [];
    }

    matchStringsWithoutSpecialChars(fieldName:string,str1: string, str2: string): boolean {
      const skipDefaultFieldName="type,actionType,errorROEID,firmROEID,CATReporterIMID";
      // Define a regular expression to match non-alphanumeric characters (including spaces)
      // The `g` flag ensures all occurrences are replaced.
      const nonAlphanumericRegex = /[^a-zA-Z1-9]/g;
      var cleanedStr1=str1.trim();
      var cleanedStr2=str2.trim();
        if(cleanedStr1.length>0 && cleanedStr2.length>0){
          if(fieldName.includes("Date") || fieldName.includes("Timestamp")){
            str1 = str1.replace(/T/g, '');
            str2 = str2.replace(/T/g, '');
            str1 = str1.replace(/\s+/g, "");
            str2 = str2.replace(/\s+/g, "");
            cleanedStr1 = str1.replace(nonAlphanumericRegex, '');
            cleanedStr2 = str2.replace(nonAlphanumericRegex, '');
          }
        
          return (cleanedStr1 == cleanedStr2) || skipDefaultFieldName.includes(fieldName);
      }
      return true;
    }

  getDeviceName(): string {
    const platform = navigator.platform || "Unknown OS";

    const userAgent = navigator.userAgent;

    let browser = "Unknown Browser";

    if (userAgent.includes("Chrome")) {
      browser = "Chrome";
    } else if (userAgent.includes("Firefox")) {
      browser = "Firefox";
    } else if (userAgent.includes("Safari")) {
      browser = "Safari";
    } else if (userAgent.includes("Edge")) {
      browser = "Edge";
    }

    return `${platform} - ${browser}`;
  }
}
